enum SupportedLayout {
  GRID = 'grid',
  LIST = 'list'
}

export default SupportedLayout;
